
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h4 {...{
      "id": "ad-selection-message-visibility"
    }}>{`Ad selection message visibility`}</h4>
    <p>{`When ad products are shown to hirers, they may have associated messages.
Some messages should always be visible and others should be visible when a product is selected or not selected.`}</p>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://developer.seek.com/schema/#/query/seekAnzHirerAdvertisementCreationProducts"
      }}><inlineCode parentName="a">{`seekAnzHirerAdvertisementCreationProducts`}</inlineCode></a>{`, `}<a parentName="p" {...{
        "href": "https://developer.seek.com/schema/#/query/seekAnzHirerAdvertisementModificationProducts"
      }}><inlineCode parentName="a">{`seekAnzHirerAdvertisementModificationProducts`}</inlineCode></a>{` and `}<a parentName="p" {...{
        "href": "https://developer.seek.com/schema/#/query/seekAnzHirerAdvertisementModificationProductsAlt"
      }}><inlineCode parentName="a">{`seekAnzHirerAdvertisementModificationProductsAlt`}</inlineCode></a>{` queries have been extended to include a field named `}<inlineCode parentName="p">{`visibilityCode`}</inlineCode>{`. It has 3 possible values:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li"><inlineCode parentName="p">{`Always`}</inlineCode>{` indicates that the message should always be visible.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li"><inlineCode parentName="p">{`ProductSelected`}</inlineCode>{` indicates that the message should be visible when the product is selected.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li"><inlineCode parentName="p">{`ProductNotSelected`}</inlineCode>{` indicates that the message should be visible when the product is not selected.`}</p>
      </li>
    </ol>
    <pre><code parentName="pre" {...{
        "658": true,
        "1300": true,
        "className": "language-scoobie-merged-code",
        "metastring": "[{\"type\":\"code\",\"lang\":\"graphql\",\"meta\":\"lovato-ignore-no-deprecated-schema\",\"value\":\"query seekAnzHirerAdvertisementProducts(\\n  $advertisementId: String!\\n  $hirerId: String!\\n  $draftAdvertisement: SeekAnzAdProductAdvertisementDraftInput!\\n) {\\n  seekAnzHirerAdvertisementModificationProducts(\\n    hirerId: $hirerId\\n    advertisementId: $advertisementId\\n    draftAdvertisement: $draftAdvertisement\\n  ) {\\n    name\\n    messages {\\n      visibilityCode\\n      content\\n    }\\n  }\\n}\",\"position\":{\"start\":{\"line\":12,\"column\":1,\"offset\":744},\"end\":{\"line\":30,\"column\":4,\"offset\":1180},\"indent\":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]}},{\"type\":\"code\",\"lang\":\"json\",\"meta\":null,\"value\":\"{\\n  \\\"hirerId\\\": \\\"seekAnzPublicTest:organization:seek:93WyyF1h\\\",\\n  \\\"advertisementId\\\": \\\"seekAnzPublicTest:positionProfile:jobAd:2782PZfXV\\\",\\n  \\\"draftAdvertisement\\\": {\\n    \\\"typeCode\\\": \\\"Classic\\\",\\n    \\\"hirerJobReference\\\": \\\"Job-152\\\",\\n    \\\"positionTitle\\\": \\\"Software Developer\\\",\\n    \\\"jobCategoryId\\\": \\\"seekAnzPublicTest:jobCategory:seek:2EFstqFvP\\\",\\n    \\\"positionLocationId\\\": \\\"seekAnzPublicTest:location:seek:2vArzkyio\\\"\\n  }\\n}\",\"position\":{\"start\":{\"line\":32,\"column\":1,\"offset\":1182},\"end\":{\"line\":44,\"column\":4,\"offset\":1607},\"indent\":[1,1,1,1,1,1,1,1,1,1,1,1]}},{\"type\":\"code\",\"lang\":\"json\",\"meta\":null,\"value\":\"{\\n  \\\"seekAnzHirerAdvertisementModificationProducts\\\": [\\n    {\\n      \\\"name\\\": \\\"Classic\\\",\\n      \\\"messages\\\": []\\n    },\\n    {\\n      \\\"name\\\": \\\"StandOut\\\",\\n      \\\"messages\\\": [\\n        {\\n          \\\"visibilityCode\\\": \\\"ProductSelected\\\",\\n          \\\"content\\\": \\\"Your changes incur a price increase. AUD 49.50 will be deducted from your SEEK Contract.\\\"\\n        }\\n      ]\\n    },\\n    {\\n      \\\"name\\\": \\\"Premium\\\",\\n      \\\"messages\\\": [\\n        {\\n          \\\"visibilityCode\\\": \\\"Always\\\",\\n          \\\"content\\\": \\\"Not supported while updating your ad. For help, call 1300 658 700.\\\"\\n        }\\n      ]\\n    }\\n  ]\\n}\",\"position\":{\"start\":{\"line\":46,\"column\":1,\"offset\":1609},\"end\":{\"line\":73,\"column\":4,\"offset\":2199},\"indent\":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]}}]",
        "[{\"type\":\"code\",\"lang\":\"graphql\",\"meta\":\"lovato-ignore-no-deprecated-schema\",\"value\":\"query": true,
        "seekAnzHirerAdvertisementProducts(\\n": true,
        "": true,
        "$advertisementId:": true,
        "String!\\n": true,
        "$hirerId:": true,
        "$draftAdvertisement:": true,
        "SeekAnzAdProductAdvertisementDraftInput!\\n)": true,
        "{\\n": true,
        "seekAnzHirerAdvertisementModificationProducts(\\n": true,
        "hirerId:": true,
        "$hirerId\\n": true,
        "advertisementId:": true,
        "$advertisementId\\n": true,
        "draftAdvertisement:": true,
        "$draftAdvertisement\\n": true,
        ")": true,
        "name\\n": true,
        "messages": true,
        "visibilityCode\\n": true,
        "content\\n": true,
        "}\\n": true,
        "}\\n}\",\"position\":{\"start\":{\"line\":12,\"column\":1,\"offset\":744},\"end\":{\"line\":30,\"column\":4,\"offset\":1180},\"indent\":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]}},{\"type\":\"code\",\"lang\":\"json\",\"meta\":null,\"value\":\"{\\n": true,
        "\\\"hirerId\\\":": true,
        "\\\"seekAnzPublicTest:organization:seek:93WyyF1h\\\",\\n": true,
        "\\\"advertisementId\\\":": true,
        "\\\"seekAnzPublicTest:positionProfile:jobAd:2782PZfXV\\\",\\n": true,
        "\\\"draftAdvertisement\\\":": true,
        "\\\"typeCode\\\":": true,
        "\\\"Classic\\\",\\n": true,
        "\\\"hirerJobReference\\\":": true,
        "\\\"Job-152\\\",\\n": true,
        "\\\"positionTitle\\\":": true,
        "\\\"Software": true,
        "Developer\\\",\\n": true,
        "\\\"jobCategoryId\\\":": true,
        "\\\"seekAnzPublicTest:jobCategory:seek:2EFstqFvP\\\",\\n": true,
        "\\\"positionLocationId\\\":": true,
        "\\\"seekAnzPublicTest:location:seek:2vArzkyio\\\"\\n": true,
        "}\\n}\",\"position\":{\"start\":{\"line\":32,\"column\":1,\"offset\":1182},\"end\":{\"line\":44,\"column\":4,\"offset\":1607},\"indent\":[1,1,1,1,1,1,1,1,1,1,1,1]}},{\"type\":\"code\",\"lang\":\"json\",\"meta\":null,\"value\":\"{\\n": true,
        "\\\"seekAnzHirerAdvertisementModificationProducts\\\":": true,
        "[\\n": true,
        "\\\"name\\\":": true,
        "\\\"messages\\\":": true,
        "[]\\n": true,
        "},\\n": true,
        "\\\"StandOut\\\",\\n": true,
        "\\\"visibilityCode\\\":": true,
        "\\\"ProductSelected\\\",\\n": true,
        "\\\"content\\\":": true,
        "\\\"Your": true,
        "changes": true,
        "incur": true,
        "a": true,
        "price": true,
        "increase.": true,
        "AUD 49.50": true,
        "will": true,
        "be": true,
        "deducted": true,
        "from": true,
        "your": true,
        "SEEK": true,
        "Contract.\\\"\\n": true,
        "]\\n": true,
        "\\\"Premium\\\",\\n": true,
        "\\\"Always\\\",\\n": true,
        "\\\"Not": true,
        "supported": true,
        "while": true,
        "updating": true,
        "ad.": true,
        "For": true,
        "help,": true,
        "call": true,
        "700.\\\"\\n": true,
        "]\\n}\",\"position\":{\"start\":{\"line\":46,\"column\":1,\"offset\":1609},\"end\":{\"line\":73,\"column\":4,\"offset\":2199},\"indent\":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]}}]": true
      }}>{`query seekAnzHirerAdvertisementProducts(
  $advertisementId: String!
  $hirerId: String!
  $draftAdvertisement: SeekAnzAdProductAdvertisementDraftInput!
) {
  seekAnzHirerAdvertisementModificationProducts(
    hirerId: $hirerId
    advertisementId: $advertisementId
    draftAdvertisement: $draftAdvertisement
  ) {
    name
    messages {
      visibilityCode
      content
    }
  }
}
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;